import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/MainPopup.css';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function MainPopup() {
    const [popupData, setPopupData] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const { i18n, t } = useTranslation();

    useEffect(() => {
        const checkPopup = async () => {
            const hideUntil = localStorage.getItem('hide_popup_until');
            if (hideUntil && new Date().getTime() < Number(hideUntil)) return;

            try {
                const res = await fetch(`${API_BASE}/api/popup_list.php`);
                const data = await res.json();
                
                // 활성화된 팝업 중 최신 데이터 하나 선택
                const activePopup = Array.isArray(data) 
                    ? data.find(p => Number(p.is_active) === 1) 
                    : null;

                if (activePopup) {
                    setPopupData(activePopup);
                    setTimeout(() => setIsVisible(true), 500);
                }
            } catch (e) {
                console.error("Popup fetch error:", e);
            }
        };

        checkPopup();
    }, []);

    const handleClose = (withHide = false) => {
        setIsClosing(true); // 애니메이션 시작 클래스 부여

        if (withHide) {
            const expireDate = new Date().getTime() + 24 * 60 * 60 * 1000;
            localStorage.setItem('hide_popup_until', expireDate.toString());
        }

        // CSS 애니메이션 시간(0.4s)이 끝난 후 컴포넌트 제거
        setTimeout(() => {
            setIsVisible(false);
            setIsClosing(false);
        }, 400);
    };

    const hideForDay = () => {
        const expireDate = new Date().getTime() + 24 * 60 * 60 * 1000;
        localStorage.setItem('hide_popup_until', expireDate.toString());
        setIsVisible(false);
    };

    if (!popupData || !isVisible) return null;

    // DB에서 가져온 다국어 데이터 (title_kr, title_en 등)
    const lang = i18n.language.toLowerCase();
    const title = popupData[`title_${lang}`] || popupData.title_kr;
    const content = popupData[`content_${lang}`] || popupData.content_kr;

    return (
        <div className={`main-popup-overlay ${isClosing ? 'is-closing' : ''}`}>
            {/* isClosing 상태에 따라 클래스 추가 */}
            <div className={`main-popup-content ${isClosing ? 'is-closing' : ''}`}>
                {popupData.image_url && (
                    <div className="popup-image-wrap">
                        <img src={`${API_BASE}${popupData.image_url}`} alt="popup" />
                    </div>
                )}

                <div className="popup-text-wrap">
                    <h3>{title}</h3>
                    <p>{content}</p>
                    
                    {popupData.link_url && (
                        <a 
                            href={popupData.link_url} 
                            target="_blank" 
                            rel="noreferrer" 
                            className="popup-link-btn"
                        >
                            {t('popup_more')}
                        </a>
                    )}
                </div>

                <div className="popup-footer">
                    <button onClick={() => handleClose(true)} className="hide-btn">
                        {t('popup_hide')}
                    </button>
                    <button onClick={() => handleClose(false)} className="close-btn">
                        {t('popup_close')}
                    </button>
                </div>
            </div>
        </div>
    );
}